// UGA's undergraduate majors (#2596, founder 2026-09-30: "majors offered by
// the college in the public page"). Read on 2026-09-30 from the official UGA
// Bulletin's Programs search (bulletin.uga.edu/Program/Index) filtered to
// Undergraduate Major: 151 majors, 161 degree links, all nine result pages.
// One row per degree link (Chemistry has a BS and a BSChem). The school is
// the Bulletin's own college code on each degree link (IDc=ARTS is the
// Franklin College, BUS the Terry College, and so on), so a major offered
// through two colleges (Honors Interdisciplinary Studies) sits under each.
// Computer Science carries IDc=ARTS though its contact is the School of
// Computing, and the Economics AB carries IDc=BUS; the Bulletin's codes are
// kept. Names and degree abbreviations (AB, BSA, BMUS...) are the Bulletin's.
// Minors, certificates and graduate programs are left out. The KB's majors
// list (from the Career Center's majors checklist) was the starting point;
// the Bulletin wins.
const majors = {
    "slug": "university-of-georgia",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in the official UGA Bulletin, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Franklin College of Arts and Sciences",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "AB"
                },
                {
                    "name": "Anthropology",
                    "degree": "AB"
                },
                {
                    "name": "Arabic",
                    "degree": "AB"
                },
                {
                    "name": "Art BFA - Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Ceramics",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Drawing and Painting",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Fabric Design",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Interior Design",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Jewelry and Metalwork",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Photography and Expanded Media",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Printmaking",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Scientific Illustration",
                    "degree": "BFA"
                },
                {
                    "name": "Art BFA - Sculpture and Technology",
                    "degree": "BFA"
                },
                {
                    "name": "Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "AB"
                },
                {
                    "name": "Art: Interdisciplinary Art",
                    "degree": "AB"
                },
                {
                    "name": "Asian Languages and Literature",
                    "degree": "AB"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Cellular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BSCHEM"
                },
                {
                    "name": "Classics",
                    "degree": "AB"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "AB"
                },
                {
                    "name": "Communication Studies",
                    "degree": "AB"
                },
                {
                    "name": "Comparative Literature and Intercultural Studies",
                    "degree": "AB"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "AB"
                },
                {
                    "name": "Dance",
                    "degree": "AB"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "AB"
                },
                {
                    "name": "Film",
                    "degree": "AB"
                },
                {
                    "name": "French",
                    "degree": "AB"
                },
                {
                    "name": "Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "AB"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "AB"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "AB"
                },
                {
                    "name": "History",
                    "degree": "AB"
                },
                {
                    "name": "Honors Interdisciplinary Studies",
                    "degree": "AB"
                },
                {
                    "name": "Honors Interdisciplinary Studies",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "AB"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BFA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "AB"
                },
                {
                    "name": "Linguistics",
                    "degree": "AB"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "AB"
                },
                {
                    "name": "Music BMus - Music Composition",
                    "degree": "BMUS"
                },
                {
                    "name": "Music BMus - Music Education",
                    "degree": "BMUS"
                },
                {
                    "name": "Music BMus - Music Performance",
                    "degree": "BMUS"
                },
                {
                    "name": "Music BMus - Music Theory",
                    "degree": "BMUS"
                },
                {
                    "name": "Music BMus - Music Therapy",
                    "degree": "BMUS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Ocean Science",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "AB"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Plant Biology",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religion",
                    "degree": "AB"
                },
                {
                    "name": "Romance Languages",
                    "degree": "AB"
                },
                {
                    "name": "Russian",
                    "degree": "AB"
                },
                {
                    "name": "Sociology",
                    "degree": "AB"
                },
                {
                    "name": "Spanish",
                    "degree": "AB"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "AB"
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "AB"
                }
            ]
        },
        {
            "name": "College of Agricultural and Environmental Sciences",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": "BSA"
                },
                {
                    "name": "Agricultural and Applied Economics",
                    "degree": "BSA"
                },
                {
                    "name": "Agricultural and Environmental Science Communication",
                    "degree": "BSA"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "BSA"
                },
                {
                    "name": "Agriscience and Environmental Systems",
                    "degree": "BSA"
                },
                {
                    "name": "Animal and Dairy Science",
                    "degree": "BSA"
                },
                {
                    "name": "Animal Biosciences",
                    "degree": "BS"
                },
                {
                    "name": "Animal Health",
                    "degree": "BSA"
                },
                {
                    "name": "Applied Biotechnology",
                    "degree": "BSAB"
                },
                {
                    "name": "Avian Biology",
                    "degree": "BSA"
                },
                {
                    "name": "Biological Science",
                    "degree": "BSA"
                },
                {
                    "name": "Entomology",
                    "degree": "BSES"
                },
                {
                    "name": "Environmental Economics and Management",
                    "degree": "BSES"
                },
                {
                    "name": "Environmental Resource Science",
                    "degree": "BSES"
                },
                {
                    "name": "Food Science",
                    "degree": "BSA"
                },
                {
                    "name": "Honors Interdisciplinary Studies",
                    "degree": "BSA"
                },
                {
                    "name": "Horticulture",
                    "degree": "BSA"
                },
                {
                    "name": "Hospitality and Food Industry Management",
                    "degree": "BSA"
                },
                {
                    "name": "Poultry Science",
                    "degree": "BSA"
                },
                {
                    "name": "Regenerative Bioscience",
                    "degree": "BS"
                },
                {
                    "name": "Turfgrass Management",
                    "degree": "BSA"
                }
            ]
        },
        {
            "name": "Terry College of Business",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Accounting and International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "AB"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Economics and International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Finance and International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "General Business",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management and International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Management Information Systems and International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing and International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate and International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance and International Business Co-Major",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Mary Frances Early College of Education",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BSED"
                },
                {
                    "name": "English Education",
                    "degree": "BSED"
                },
                {
                    "name": "Exercise and Sport Science",
                    "degree": "BS"
                },
                {
                    "name": "Health and Physical Education",
                    "degree": "BSED"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BSED"
                },
                {
                    "name": "Science Education",
                    "degree": "BSED"
                },
                {
                    "name": "Social Studies Education",
                    "degree": "BSED"
                },
                {
                    "name": "Special Education",
                    "degree": "BSED"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "TESOL and World Language Education",
                    "degree": "BSED"
                },
                {
                    "name": "Workforce Education",
                    "degree": "BSED"
                }
            ]
        },
        {
            "name": "College of Family and Consumer Sciences",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Consumer Economics",
                    "degree": "BSFCS"
                },
                {
                    "name": "Culinary Science and Nutrition",
                    "degree": "BSFCS"
                },
                {
                    "name": "Dietetics",
                    "degree": "BSFCS"
                },
                {
                    "name": "Family and Consumer Sciences Education",
                    "degree": "BSFCS"
                },
                {
                    "name": "Fashion Merchandising",
                    "degree": "BSFCS"
                },
                {
                    "name": "Financial Planning",
                    "degree": "BSFCS"
                },
                {
                    "name": "Furnishings and Interiors",
                    "degree": "BSFCS"
                },
                {
                    "name": "Housing Management and Policy",
                    "degree": "BSFCS"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BSFCS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BSFCS"
                },
                {
                    "name": "Social Entrepreneurship for Consumer Well-Being",
                    "degree": "BSFCS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Agricultural Engineering",
                    "degree": "BSAE"
                },
                {
                    "name": "Biochemical Engineering",
                    "degree": "BSBCHE"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Systems Engineering",
                    "degree": "BSCSE"
                },
                {
                    "name": "Electrical and Electronics Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSENVE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Grady College of Journalism and Mass Communication",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "AB"
                },
                {
                    "name": "Entertainment and Media Studies",
                    "degree": "AB"
                },
                {
                    "name": "Journalism",
                    "degree": "AB"
                },
                {
                    "name": "Public Relations",
                    "degree": "AB"
                }
            ]
        },
        {
            "name": "Warnell School of Forestry and Natural Resources",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Fisheries and Wildlife",
                    "degree": "BSFR"
                },
                {
                    "name": "Forestry",
                    "degree": "BSFR"
                },
                {
                    "name": "Natural Resource Management and Sustainability",
                    "degree": "BSFR"
                },
                {
                    "name": "Parks, Recreation, and Tourism Management",
                    "degree": "BSFR"
                }
            ]
        },
        {
            "name": "School of Public and International Affairs",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "International Affairs",
                    "degree": "AB"
                },
                {
                    "name": "Political Science",
                    "degree": "AB"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Odum School of Ecology",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Ecology",
                    "degree": "AB"
                },
                {
                    "name": "Ecology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Public Health",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Environmental Health",
                    "degree": "BSEH"
                },
                {
                    "name": "Health Promotion",
                    "degree": "BSHP"
                }
            ]
        },
        {
            "name": "College of Environment and Design",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Pharmaceutical and Biomedical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine",
            "source": {
                "label": "UGA Bulletin, Programs, Undergraduate Major",
                "url": "https://bulletin.uga.edu/Program/Index"
            },
            "majors": [
                {
                    "name": "Biomedical Physiology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
